/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialAnalyticsTrafficPerPostResponse } from '../../models/editorial-analytics-traffic-per-post-response';

export interface GetEditorialAnalyticsTrafficPerPost$Params {
  companyId?: number;
}

export function getEditorialAnalyticsTrafficPerPost(http: HttpClient, rootUrl: string, params?: GetEditorialAnalyticsTrafficPerPost$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialAnalyticsTrafficPerPostResponse>> {
  const rb = new RequestBuilder(rootUrl, getEditorialAnalyticsTrafficPerPost.PATH, 'get');
  if (params) {
    rb.query('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditorialAnalyticsTrafficPerPostResponse>;
    })
  );
}

getEditorialAnalyticsTrafficPerPost.PATH = '/api/editorial/analytics/traffic-per-post';
